module.exports = __webpack_public_path__ + "img/logo.887bfb44.png";